import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-next-event',
  templateUrl: './next-event.component.html',
  styleUrls: ['./next-event.component.css']
})
export class NextEventComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
